export default __webpack_public_path__ + "static/media/logo_small.153862c0.png";